import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { SecurityApiClient } from "../api-client/api-client";
import type { AddTraceResponse } from "../types";

export default function useAddTraceMutation(options?: UseMutationOptions<AddTraceResponse, Error>) {
  return useMutation<AddTraceResponse, Error>({
    mutationFn: async () => {
      const res = await SecurityApiClient.openDemandOfAuthentication();
      if (!res.success) {
        throw new Error(res.data?.action);
      }
      return res.data;
    },
    ...options
  });
}
